import { View } from "@react-pdf/renderer";
import { stripHtmlToPlainText } from "../../../../../helpers/interventionHtml";
import { COLORS } from "../../../../forms/pdf-components/PdfStyles";
import { PdfH2 } from "../../../../forms/pdf-components/PdfText";
import { PdfSection } from "../../../../forms/pdf-components/PdfLayout";
import { PdfCheckItem } from "../../../../forms/pdf-components/PdfCheckItem";

const CLINICAL_ISSUES_OPTIONS = [
  { value: "Drug - Drug Interaction", label: "Drug - Drug Interaction" },
  { value: "Drug - Disease Interaction", label: "Drug - Disease Interaction" },
  { value: "Adverse Drug Interaction", label: "Adverse Drug Interaction" },
  {
    value: "Drug Level Monitoring (narrow therapeutic index)",
    label: "Drug Level Monitoring (narrow therapeutic index)",
  },
  {
    value: "Therapy Change / Tolerance/ Effectiveness",
    label: "Therapy Change / Tolerance/ Effectiveness",
  },
  { value: "Medication Adherence", label: "Medication Adherence" },
  {
    value: "Multiple Drugs (Poly Pharmacy)",
    label: "Multiple Drugs (Poly Pharmacy)",
  },
  {
    value: "Complex Medication Regimen",
    label: "Complex Medication Regimen",
  },
  { value: "Recent or Frequent Falls", label: "Recent or Frequent Falls" },
  {
    value: "Frequent Hospital Admissions",
    label: "Frequent Hospital Admissions",
  },
  {
    value: "Chronic Disease Management",
    label: "Chronic Disease Management",
  },
  { value: "Under Treated Conditions", label: "Under Treated Conditions" },
  { value: "Untreated Conditions", label: "Untreated Conditions" },
  { value: "Other", label: "Other" },
];

/**
 * PdfMedicationConditionReview
 *
 * Props:
 *   pharmacistFollowUp — { additionalClinicalIssues: string[], otherIssue: string }
 */
export const PdfMedicationConditionReview = ({ pharmacistFollowUp = {} }) => {
  const { additionalClinicalIssues = [], otherIssue = "" } =
    pharmacistFollowUp || {};

  const checkedIssues = CLINICAL_ISSUES_OPTIONS.filter((opt) =>
    additionalClinicalIssues.includes(opt.value)
  );
  const otherIssueText = stripHtmlToPlainText(otherIssue || "").trim();
  const hasAnyIssues = checkedIssues.length > 0 || otherIssueText.length > 0;

  return (
    <PdfSection>
      <PdfH2 style={{ marginBottom: hasAnyIssues ? 4 : 0 }}>
        {`Medication / Condition Review${
          !hasAnyIssues ? " - No additional issues at this time" : ""
        }`}
      </PdfH2>

      {hasAnyIssues && (
        <>
          <View
            style={{
              borderWidth: 1,
              borderColor: COLORS.border,
              backgroundColor: COLORS.bg,
              padding: 5,
              marginBottom: 4,
            }}
          >
            {checkedIssues.map((opt) => (
              <PdfCheckItem key={opt.value} label={opt.label} checked />
            ))}
            {otherIssueText.length > 0 && (
              <PdfCheckItem label={`Other: ${otherIssueText}`} checked />
            )}
          </View>

          {/* Pharmacist Suggestions — blank write-in box, matches DOM form */}
          <View
            style={{
              borderWidth: 1,
              borderColor: COLORS.border,
              backgroundColor: COLORS.bg,
              padding: 5,
              minHeight: 40,
            }}
          >
            <PdfH2 style={{ marginBottom: 0 }}>Pharmacist Suggestions</PdfH2>
          </View>
        </>
      )}
    </PdfSection>
  );
};
